module.exports = __webpack_public_path__ + "img/popUp_menu_small.70b6310.webp";